import { DesignSystem } from '@microsoft/fast-foundation';
import * as tokens from './_config/tokens';
import * as values from './_config/values';
import { provideTokens } from './design-system-provider';
export function createDesignSystemProxy(designSystem) {
    return new Proxy(designSystem, {
        get: (target, prop, ...rest) => {
            if (['withPrefix', 'withShadowRootMode', 'withElementDisambiguation'].includes(prop)) {
                throw new Error('Modification of the Design System is not allowed.');
            }
            return Reflect.get(target, prop, ...rest);
        },
    });
}
/**
 * Provides a design system for the specified element either by returning one that was
 * already created for that element or creating one.
 * @param element - The element to root the design system at. By default, this is the body.
 * @returns A Foundation Design System
 * @public
 */
export const provideDesignSystem = (element, prefix = 'foundation') => {
    if (element) {
        provideTokens(tokens, values, element);
    }
    const designSystem = DesignSystem.getOrCreate(element).withPrefix(prefix);
    return createDesignSystemProxy(designSystem);
};
